import { channelConstants } from '../_constants';
import { channelService } from '../_services';
import { alertActions } from './';

export const channelActions = {
  create,
  update
}

function create(data) {
  let channel = data.channel.channel_type;

  return dispatch => {
    dispatch(request(channel, channelConstants.CHANNEL_INTEGRATION_REQUEST));

    return channelService.create(data)
      .then(data => {
        return dispatch(success(data, channelConstants.CHANNEL_INTEGRATION_SUCCESS));
      }, error => {
        dispatch(alertActions.failure(error));
        return dispatch(failure(error, channelConstants.CHANNEL_INTEGRATION_FAILURE));
      })
  }
}

function update(data) {
  let channel = data.channel.channel_type;

  return dispatch => {
    dispatch(request(channel, channelConstants.UPDATE_INTEGRATION_REQUEST));

    return channelService.update(data)
      .then(data => {
        return dispatch(success(data, channelConstants.UPDATE_INTEGRATION_SUCCESS));
      }, error => {
        dispatch(alertActions.failure(error));
        return dispatch(failure(error, channelConstants.UPDATE_INTEGRATION_FAILURE));
      })
  }
}

const request = (data, constant) => {
  return { type: constant, data }
}

const success = (data, constant) => {
  return { type: constant, data }
}

const failure = (data, constant) => {
  return { type: constant, data }
}